module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-select', {
    staticClass: "arriveClass",
    attrs: {
      "placeholder": _vm.Language('省份')
    },
    on: {
      "change": function($event) {
        return _vm.provinceChange($event)
      }
    },
    model: {
      value: (_vm.province),
      callback: function($$v) {
        _vm.province = $$v
      },
      expression: "province"
    }
  }, _vm._l((_vm.provinceList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticClass: "arriveClass",
    attrs: {
      "placeholder": _vm.Language('城市')
    },
    on: {
      "change": function($event) {
        return _vm.cityChange($event)
      }
    },
    model: {
      value: (_vm.citty),
      callback: function($$v) {
        _vm.citty = $$v
      },
      expression: "citty"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticClass: "arriveClass",
    attrs: {
      "placeholder": _vm.Language('地区')
    },
    model: {
      value: (_vm.area),
      callback: function($$v) {
        _vm.area = $$v
      },
      expression: "area"
    }
  }, _vm._l((_vm.countyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-72936d02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Sass/components/AreaSelect.vue
// module id = 1336
// module chunks = 5